import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [supplier, setSupplier] = useState(null);
  const [loading, setLoading] = useState(true);

  const getToken = () => localStorage.getItem('artflow_token');
  const getUserType = () => localStorage.getItem('artflow_type'); // 'user' | 'supplier'

  const setAuthHeader = (token) => {
    if (token) axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    else delete axios.defaults.headers.common['Authorization'];
  };

  const fetchMe = useCallback(async () => {
    const token = getToken();
    if (!token) { setLoading(false); return; }
    setAuthHeader(token);
    try {
      const res = await axios.get('/api/auth/me');
      const data = res.data;
      if (data.type === 'supplier') setSupplier(data);
      else setUser(data);
    } catch {
      localStorage.removeItem('artflow_token');
      localStorage.removeItem('artflow_type');
      setAuthHeader(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchMe(); }, [fetchMe]);

  const loginUser = (token, userData) => {
    localStorage.setItem('artflow_token', token);
    localStorage.setItem('artflow_type', 'user');
    setAuthHeader(token);
    setUser(userData);
    setSupplier(null);
  };

  const loginSupplier = (token, supplierData) => {
    localStorage.setItem('artflow_token', token);
    localStorage.setItem('artflow_type', 'supplier');
    setAuthHeader(token);
    setSupplier(supplierData);
    setUser(null);
  };

  const logout = () => {
    localStorage.removeItem('artflow_token');
    localStorage.removeItem('artflow_type');
    setAuthHeader(null);
    setUser(null);
    setSupplier(null);
  };

  return (
    <AuthContext.Provider value={{
      user, supplier, loading,
      isLoggedIn: !!(user || supplier),
      isUser: !!user,
      isSupplier: !!supplier,
      isAdmin: user?.role === 'admin' || user?.role === 'superadmin',
      isSuperAdmin: user?.role === 'superadmin',
      userType: getUserType(),
      loginUser, loginSupplier, logout, fetchMe
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
